import React, { useEffect, useState } from "react";
import "../../../src/App.css";
import { useTranslation } from "react-i18next";
import instance from "../../axios/axiosConfig";
import SpinnerLoading from "./SpinnerLoading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import close_modal from "../../assets/images/pictures/icon/close-modal.svg";
// import { postData } from "../../utils/api";

const Modal = ({
  setOpenModal,
  handleOverlayClick,
  modalRef,
  heading,
  description,
  type,
}) => {
  const { t } = useTranslation();
  // const [dialogOpen, setDialogOpen] = useState(false);
  // const [errorDialogOpen,setErrorDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const successNotify = () =>
    toast.success(t("success-dialog.message"), {
      position: "bottom-right",
    });

  const failedNotify = () =>
    toast.error(t("error-dialog.message"), {
      position: "bottom-right",
    });

  useEffect(() => {
    if (isLoading === true) {
      document.body.style.overflow = "hidden";
    }
  }, [isLoading]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    phone: "",
    message: "",
  });

  const [validationMessages, setValidationMessages] = useState({
    name: "",
    email: "",

    phone: "",
    message: "",
  });

  useEffect(() => {
    const { name, email, phone, message } = formData;
    if (
      name.trim() !== "" &&
      email.trim() !== "" &&
      phone.trim() !== "" &&
      message.trim() !== "" &&
      Object.values(validationMessages).every((message) => message === "")
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [formData, validationMessages]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "name") {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        name: value.trim() === "" ? t("validation.name-required") : "",
      }));
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        email:
          !value.trim() === "" || emailRegex.test(value.trim())
            ? ""
            : t("validation.email-invalid"),
      }));
    }

    // if (name === "organization") {
    //   setValidationMessages((prevMessages) => ({
    //     ...prevMessages,
    //     organization:
    //       value.trim() === "" ? t("validation.organization-required") : "",
    //   }));
    // }

    if (name === "phone") {
      const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        phone:
          !value.trim() === "" || phoneRegex.test(value.trim())
            ? ""
            : t("validation.phone-invalid"),
      }));
    }

    if (name === "message") {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        message: value.trim() === "" ? t("validation.message-required") : "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
    const newValidationMessages = {
      name: "",
      email: "",
      organization: "",
      phone: "",
      message: "",
    };

    if (!formData.name.trim()) {
      newValidationMessages.name = t("validation.name-required");
    }

    if (!formData.message.trim()) {
      newValidationMessages.message = t("validation.message-required");
    }

    // if (!formData.organization.trim()) {
    //   newValidationMessages.organization = t(
    //     "validation.organization-required"
    //   );
    // }

    if (!formData.email.trim()) {
      newValidationMessages.email = t("validation.email-required");
    } else if (!emailRegex.test(formData.email.trim())) {
      newValidationMessages.email = t("validation.email-invalid");
    }

    if (!formData.phone.trim()) {
      newValidationMessages.phone = t("validation.phone-required");
    } else if (!phoneRegex.test(formData.phone.trim())) {
      newValidationMessages.phone = t("validation.phone-invalid");
    }

    setValidationMessages(newValidationMessages);

    if (!Object.values(newValidationMessages).some((msg) => msg !== "")) {
      const data = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        phone: formData.phone,
        organization: formData.organization,
        type: type,
      };

      try {
        setIsLoading(true);

        await fetch("/sendContact", data)
          .then(function (response) {
            if (response.data === "success") {
              setIsLoading(false);
              successNotify();
              setFormData({
                name: "",
                email: "",
                message: "",
                organization: "",
                phone: "",
              });
              setValidationMessages({
                name: "",
                email: "",
                message: "",
                organization: "",
                phone: "",
              });
              newValidationMessages.email = "";
              newValidationMessages.message = "";
              newValidationMessages.name = "";
              newValidationMessages.organization = "";
              newValidationMessages.phone = "";
              setOpenModal(false);
            } else {
              setIsLoading(false);
              failedNotify();
            }
          })
          .catch(function (error) {
            console.log(error);
            setIsLoading(false);
            failedNotify();
          });
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
        failedNotify();
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="modalBackground" onClick={handleOverlayClick}>
      <div className="modalContainer" id="modal" ref={modalRef}>
        <div className="closeModal">
          <button
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <img src={close_modal} alt="close_modal" />
          </button>
        </div>
        <div className="modalContent">
          <form onSubmit={handleSubmit}>
            <p className="text-center mx-auto font-weight-bold font-20 text-uppercase">
              {heading}
            </p>
            <h4 className="text-center font-14">{description}</h4>
            <div className="form-group">
              <p
                htmlFor="name"
                className="font-weight-semi-bold mx-auto text-black"
              >
                {t("modal.full-name")}&nbsp;
                <span style={{ color: "#D8513F" }}>*</span>
              </p>
              <input
                className="form-control"
                id="name"
                name="name"
                onChange={handleInputChange}
                value={formData.name}
              />
              {validationMessages.name && (
                <div className="errors--label-relative">
                  {validationMessages.name}
                </div>
              )}
            </div>

            <div className="form-group">
              <p
                htmlFor="email"
                className="mx-auto text-black font-weight-semi-bold"
              >
                {t("modal.email")}&nbsp;
                <span style={{ color: "#D8513F" }}>*</span>
              </p>
              <input
                type="text"
                className="form-control"
                id="email"
                name="email"
                onChange={handleInputChange}
                value={formData.email}
              />
              {validationMessages.email && (
                <div className="errors--label-relative">
                  {validationMessages.email}
                </div>
              )}
            </div>
            <div className="form-group">
              <p
                htmlFor="phone"
                className="font-weight-semi-bold text-black mx-auto"
              >
                {t("modal.phone-number")}&nbsp;
                <span style={{ color: "#D8513F" }}>*</span>
              </p>
              <input
                type="text"
                className="form-control"
                id="phone"
                name="phone"
                onChange={handleInputChange}
                value={formData.phone}
              />
              {validationMessages.phone && (
                <div className="errors--label-relative">
                  {validationMessages.phone}
                </div>
              )}
            </div>
            <div className="form-group">
              <p
                htmlFor="organization"
                className="font-weight-semi-bold text-black mx-auto"
              >
                {t("modal.organisation")}&nbsp;
              </p>
              <input
                type="text"
                className="form-control"
                id="organization"
                name="organization"
                onChange={handleInputChange}
                value={formData.organization}
              />
              {validationMessages.organization && (
                <div className="errors--label-relative">
                  {validationMessages.organization}
                </div>
              )}
            </div>
            <div className="form-group">
              <p
                htmlFor="message"
                className="font-weight-semi-bold text-black mx-auto"
              >
                {t("modal.message")}&nbsp;
                <span style={{ color: "#D8513F" }}>*</span>
              </p>
              <textarea
                style={{ resize: "vertical", height: "100px" }}
                className="form-control"
                id="message"
                name="message"
                onChange={handleInputChange}
                value={formData.message}
              />
              {validationMessages.message && (
                <div className="errors--label-relative">
                  {validationMessages.message}
                </div>
              )}
            </div>

            <div className="form-group">
              <div className="flex center">
                <button
                  type="submit"
                  className="btn-secondary"
                  disabled={!isValid}
                >
                  {t("modal.button-send-request")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {isLoading && <SpinnerLoading />}
      {/* {dialogOpen && <SuccessDialog setOpenDialog={setDialogOpen}/>}
      {errorDialogOpen && <ErrorDialog setOpenDialog={setErrorDialogOpen}/>} */}
      <ToastContainer />
    </div>
  );
};

export default Modal;
